import { i18n } from './index'

export const translate = (key: string, named?: Record<string, unknown>): string => {
  return i18n.global.t(key, named || {}) as string
}

export const translateTitle = (title?: string, titleKey?: string): string => {
  if (titleKey) {
    return translate(titleKey)
  }
  if (title?.startsWith('route.')) {
    return translate(title)
  }
  return title || ''
}

export const translateRouteTitle = (routeOrMeta: any): string => {
  const meta = routeOrMeta?.meta || routeOrMeta || {}
  return translateTitle(meta.title, meta.titleKey)
}
